module.exports = __webpack_public_path__ + "img/front_rise.cb1cc83d.png";